import React from "react";
import {categoryProductService} from "../jwt/_services/promotions/categoryProductService";

export const categoryProductProvider = {
    getOptions,
    getItem,
};

async function getOptions(fbDataBaseId = null){
    try {
        const listItems = await categoryProductService.search(0,100, {
            fbDataBase : {  id : fbDataBaseId },
            item : { code: null, }
        } );

        return listItems.data.map((itemData) => {
            const { id, code, description } = itemData
            let show = code != null && code !== "" ? code + " - " + description : description;
            return (
                {
                    id: id,
                    value: show,
                    label: <div><label>{show}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await categoryProductService.getItem(id);
        let show = item.code != null && item.code !== "" ? item.code + " - " + item.description : item.description;
        return (
            {
                id: item.id,
                value: show,
                label: <div><label>{show}</label></div>
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}